import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import UserDeviceRow from './UserDeviceRow';
import FormTitle from '../../../../library/form/components/FormTitle'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent, UiGridColTwo } from "../../../../library/layout/Index";

const UserDevice = (props) => {
    const { formObject, viewData } = props;

    return (
        <UiView> 
            <UiViewHeading>
                <UiTitle>
                    <span >
                        <FormTitle formObject={formObject} value='Connected Devices' />
                    </span>
                </UiTitle>
                <UiAction>
                    <FormButton formObject={formObject} id="newAddButton" ksc="a" rowKey=""
                        action={{ actionId: "new",  actionParam: { isint: 0 }, containerKey: "popup" }}
                        className="uiActionButton" text={<SarasTrans value="Add Device" />}></FormButton>
                </UiAction>
            </UiViewHeading>
            <UiViewContent>
                <UiGridColTwo>
                    <ul>
                        {viewData &&
                            Object.values(viewData).map((row, index) => (
                                <UserDeviceRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                            ))
                        }
                    </ul>
                </UiGridColTwo>
            </UiViewContent>
        </UiView>
    )
}

export default withView(UserDevice, "userDevice", "userDevice")
